<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column">
    <div
      class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-top spacing--padding-half-bottom"
    >
      {{ 'settings.barn.general' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'settings.barn.name' | translate }}</mat-label>
      <input
        matInput
        placeholder="{{ 'settings.barn.name' | translate }}"
        formControlName="name"
        data-test="barn-item__name"
      />
      <mat-error
        *ngIf="!!formGroup.controls.name.errors && formGroup.controls.name.errors.duplicateBarnName"
      >
        {{ 'settings.barn.invalid.duplicate-name' | translate }}
      </mat-error>
      <mat-error
        *ngIf="!!formGroup.controls.name.errors && formGroup.controls.name.errors.required"
      >
        {{ 'settings.barn.invalid.name' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'settings.barn.surface-area' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.0001"
        placeholder="{{ 'settings.barn.surface-area' | translate }}"
        formControlName="surfaceArea"
        data-test="barn-item__surface-area"
      />
      <span matTextSuffix class="form-field-suffix">m2</span>
      <mat-error *ngIf="formGroup.controls.surfaceArea.invalid">
        {{ 'settings.barn.invalid.surface-area' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="flex__child--auto" *ngIf="silos$ | async as silos">
      <mat-label>{{ 'settings.barn.silo' | translate }}</mat-label>
      <mat-select
        multiple
        placeholder="{{ 'settings.barn.silo' | translate }}"
        formControlName="silo"
        data-test="barn-item__silo"
      >
        <mat-option *ngFor="let silo of silos" [value]="silo">
          {{ silo.siloNumber }} - {{ silo.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="formGroup.controls.silo.errors?.required">
        {{ 'required-error' | translate }}
      </mat-error>
    </mat-form-field>

    <div
      class="spacing--padding-half-all text--bold heading-wrapper spacing--padding-top spacing--padding-half-bottom"
    >
      {{ 'settings.barn.sections' | translate }}
      <div class="border-top--gray3 horizontal-line spacing--margin-half-left"></div>
    </div>

    <div class="spacing--margin-top flex--row flex--nowrap">
      <div class="flex--column">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'settings.barn.new-section' | translate }}</mat-label>
          <input
            matInput
            formControlName="newSection"
            placeholder="{{ 'settings.barn.new-section' | translate }}"
            data-test="barn-item__new-section"
            (keydown.enter)="addNewSection($event)"
          />
        </mat-form-field>
        <agr-chips-filter
          [multiple]="true"
          [removable]="true"
          [hideClear]="true"
          (removed)="removeSection($event)"
          [items]="sections"
          data-test="barn-item__sections"
        ></agr-chips-filter>
      </div>
      <div class="flex--column">
        <button
          style="height: 60px; margin-top: 4px"
          type="button"
          mat-icon-button
          (click)="addNewSection($event)"
          data-test="barn-item__add-section"
        >
          <mat-icon>done</mat-icon>
        </button>
      </div>
    </div>
  </div>
</agr-form-dialog>
